import React from 'react';
import { Calendar, Target, Flag, CheckCircle2, Clock } from 'lucide-react';
export function SprintSummaryArtifact({
  data
}: {
  data: any;
}) {
  if (!data) return null;
  const sprints = Array.isArray(data) ? data : [data];
  if (sprints.length === 0) {
    return <div className="p-4 text-slate-500 text-sm" data-id="element-345">
        No hay sprints para mostrar.
      </div>;
  }
  return <div className="grid gap-4 p-4" data-id="element-346">
      {sprints.map((sprint, idx) => {
      const name = sprint.name || 'Sprint';
      const goal = sprint.goal || 'Sin objetivo definido';
      const state = sprint.state || sprint.status || 'active';
      const startDate = sprint.startDate ? new Date(sprint.startDate).toLocaleDateString() : 'N/A';
      const endDate = sprint.endDate ? new Date(sprint.endDate).toLocaleDateString() : 'N/A';
      // Mock progress for visual effect if not provided
      const progress = sprint.progress || Math.floor(Math.random() * 100);
      const isClosed = state.toLowerCase() === 'closed';
      const isFuture = state.toLowerCase() === 'future';
      const stateColor = isClosed ? 'bg-slate-800 text-slate-400 border-slate-700' : isFuture ? 'bg-blue-900/50 text-blue-400 border-blue-800' : 'bg-emerald-900/50 text-emerald-400 border-emerald-800';
      return <div key={sprint.id || idx} className="bg-slate-950 rounded-xl border border-slate-800 p-5 shadow-sm hover:border-slate-700 transition-colors" data-id="element-347">
            <div className="flex justify-between items-start mb-4" data-id="element-348">
              <div data-id="element-349">
                <div className="flex items-center gap-2 mb-1.5" data-id="element-350">
                  <h3 className="text-lg font-bold text-slate-100" data-id="element-351">{name}</h3>
                  <span className={`px-2 py-0.5 rounded text-[10px] font-bold uppercase tracking-wider border ${stateColor}`} data-id="element-352">
                    {state}
                  </span>
                </div>
                <p className="text-sm text-slate-400 flex items-start gap-1.5 max-w-md leading-relaxed" data-id="element-353">
                  <Target size={14} className="mt-0.5 text-indigo-400 flex-shrink-0" data-id="element-354" />

                  {goal}
                </p>
              </div>
              <div className="text-right flex flex-col items-end" data-id="element-355">
                <div className="flex items-center gap-1.5 text-xs font-medium text-slate-300 mb-1 bg-slate-900 px-2 py-1 rounded border border-slate-800" data-id="element-356">
                  <Calendar size={12} className="text-slate-500" data-id="element-357" />
                  {startDate} - {endDate}
                </div>
                <div className="text-[10px] text-slate-500 font-mono" data-id="element-358">
                  ID: {sprint.id}
                </div>
              </div>
            </div>

            {!isFuture && <div className="mt-5 pt-5 border-t border-slate-800/50" data-id="element-359">
                <div className="flex justify-between items-end mb-2" data-id="element-360">
                  <span className="text-xs font-semibold text-slate-300 flex items-center gap-1.5" data-id="element-361">
                    <Flag size={12} className="text-indigo-400" data-id="element-362" /> Progreso del
                    Sprint
                  </span>
                  <span className="text-sm font-bold text-indigo-400" data-id="element-363">
                    {progress}%
                  </span>
                </div>
                <div className="w-full bg-slate-900 rounded-full h-2.5 border border-slate-800 overflow-hidden" data-id="element-364">
                  <div className={`h-full rounded-full transition-all duration-1000 ease-out ${isClosed ? 'bg-slate-500' : 'bg-indigo-500'}`} style={{
              width: `${progress}%`
            }} data-id="element-365" />
                </div>
                <div className="flex justify-between mt-3" data-id="element-366">
                  <div className="flex items-center gap-1.5 text-xs text-slate-400 bg-slate-900/50 px-2 py-1 rounded border border-slate-800/50" data-id="element-367">
                    <CheckCircle2 size={12} className="text-emerald-500" data-id="element-368" />
                    <span data-id="element-369">Completado</span>
                  </div>
                  <div className="flex items-center gap-1.5 text-xs text-slate-400 bg-slate-900/50 px-2 py-1 rounded border border-slate-800/50" data-id="element-370">
                    <Clock size={12} className="text-amber-500" data-id="element-371" />
                    <span data-id="element-372">Pendiente</span>
                  </div>
                </div>
              </div>}
          </div>;
    })}
    </div>;
}